import React from 'react';
import classnames from 'classnames';

import './ReviewRatingChart.scss';

type Props = {
  groups;
  options;
};

const ReviewRatingChart = ({ groups, options }: Props) => {
  const baseClassName = 'ReviewRatingChart';
  return (
    <div className={baseClassName}>
      {groups.map(({ label, raw }) => (
        <div className={`${baseClassName}__group`}>
          <p className={`${baseClassName}__group__label`}>
            {label}
            &nbsp;
            <b>{raw}</b>
          </p>
          <div className={`${baseClassName}__options`}>
            {options.map((option, index) => {
              const wholeNumber = Math.floor(raw);
              const decimalFll = raw - wholeNumber;
              const percentFill = decimalFll * 100;
              const showPercentageFill = decimalFll !== 0 && index + 1 > wholeNumber && index + 1 === wholeNumber + 1;
              return (
                <div
                  className={classnames(
                    `${baseClassName}__options__option`,
                    raw >= index + 1 && `${baseClassName}__options__option--active`,
                    showPercentageFill && `${baseClassName}__options__option--with-fill`
                  )}
                >
                  <span className={`${baseClassName}__options__option__value`}>{option.value}</span>
                  {showPercentageFill && (
                    <div className={`${baseClassName}__options__option__fill`} style={{ width: `${percentFill}%` }} />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReviewRatingChart;
